import React from 'react';
import '../style.css';

interface CheckboxProps {
  name?: string;
  height?: string | number;
  width?: string | number;
  disabled?: boolean;
  value: boolean;
  setValue: (value: boolean) => void;
  color: string;
}

export const PersonalInfoCheckbox: React.FC<CheckboxProps> = (props) => {
  const { name, height, width, value, setValue, disabled, color } = props;

  return (
    <div
      className="generic-checkbox no-select"
      style={{
        height: height ? height : 20,
        width: width,
      }}
    >
      <div
        className="generic-checkbox__content"
        style={{
          background: disabled ? '#F2F2F2' : '#FFFFFF',
          border: disabled ? '1px solid #C9C9C9' : value ? `1px solid ${color}` : '1px solid #C9C9C9',
        }}
        role={'presentation'}
        onClick={() => {
          if (disabled) return;
          setValue(!value);
        }}
      >
        {value && (
          <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.125 1.875L10.4105 9.58947C8.74387 11.2561 7.91053 12.0895 6.875 12.0895C5.83947 12.0895 5.00613 11.2561 3.33947 9.58947L1.25 7.5"
              stroke={disabled ? '#c7c7c7' : color}
              style={{
                transition: 'all 0.2s',
              }}
              strokeWidth="1.25"
              strokeLinecap="round"
            />
          </svg>
        )}
      </div>
      <div
        style={{ textAlign: 'start' }}
        role={'presentation'}
        onClick={(e: any) => {
          console.log(e.target.tagName)
          if (disabled) return;
          if (e.target.tagName != 'A')
            setValue(!value);
        }}
      >
        <div className="picker__personalinfo-span"><a className='picker__href' target="_blank" href="https://bambook.place/agreement/">Даю согласие на обработку персональных данных</a></div>
      </div>
    </div>
  );
};
